import { Location } from "@angular/common";
import { Component, HostListener, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AlertController, ModalController } from "@ionic/angular";
import { TranslateService } from "@ngx-translate/core";
import { ThisPlatform } from "src/app/_services/platform.service";
import { Order, OrderItem } from "../_model/order.model";
import { Product } from "../_model/product.model";
import { CartService } from "../_services/cart.service";
import { OrderService } from "../_services/order.service";

@Component({
  selector: "app-cart",
  templateUrl: "./cart.page.html",
  styleUrls: ["./cart.page.scss"],
})
export class CartPage implements OnInit {

  cart: Product[] = [];
  description: string;
  innerWidth: any;
  providerId: string;
  checkoutButtonDisable: boolean = false;

  constructor(
    private cartService: CartService,
    private modalCtrl: ModalController,
    private alertCtrl: AlertController,
    private orderServ: OrderService,
    public alertController: AlertController,
    private router: Router,
    private translateService: TranslateService,
    private route: ActivatedRoute,
    private location: Location,
    public p: ThisPlatform
  ) { }

  ngOnInit() {

    this.innerWidth = window.innerWidth;
    this.cart = this.cartService.getCart();

    this.route.paramMap.subscribe((paramMap) => {
      if (!paramMap.has("providerId")) {
        this.location.back();
        return;
      }
      this.providerId = paramMap.get("providerId");
    });
    this.orderServ.order = new Order();
  }

  @HostListener("window:resize", ["$event"])
  onResize() {
    this.innerWidth = window.innerWidth;
  }

  decreaseCartItem(product) {
    this.cartService.decreaseProduct(product);
  }

  increaseCartItem(product) {
    this.cartService.addProduct(product);
  }

  removeCartItem(product) {
    this.cartService.removeProduct(product);
  }

  getTotal() {
    return this.cart.reduce((i, j) => i + j.price * j.amount, 0);
  }

  close() {
    this.location.back();
  }

  clearCart() {
    this.cart = [];
    this.cartService.clearCart();
    this.close();
  }

  async checkout() {
    // Perfom PayPal or Stripe checkout process
    this.checkoutButtonDisable = true;
    if (
      !this.cart.every(
        (val, i, arr) => val.companyProvider.id === arr[0].companyProvider.id
      )
    ) {
      const alert = await this.alertController.create({
        header: "Alert",
        message: "Wszystkie pozycje powinny być od jednego dostawcy.",
        buttons: [
          {
            text: this.translateService.instant("CANCEL"),
            role: "cancel",
            cssClass: "secondary",
            handler: () => {
            },
          },
          {
            text: "Ok",
            handler: () => { },
          },
        ],
      });

      return await alert.present();
    }

    this.orderServ.order.idCompanyProvider = this.cart[0].companyProvider.id;
    this.orderServ.order.description = this.description;
    this.cart.forEach((a) => {
      let item: OrderItem = new OrderItem();
      item.amount = a.amount;
      item.idProduct = a.id;
      this.orderServ.order.orderItems.push(item);
    });

    this.orderServ.createOrder().subscribe(async (res) => {

      let alert = await this.alertCtrl.create({
        header: this.translateService.instant("MARKET.MODAL_HEADER"),
        message: this.translateService.instant("MARKET.MODAL_MESSAGE"),
        buttons: [{
          text: "OK"
        }]
      });
      alert.present().then(() => {
        this.modalCtrl.dismiss()
      });
      await alert.onDidDismiss();
      this.cartService.clearCart();
      this.cart = [];
      this.router.navigate(['/app/market'], {queryParams: {section: 'orders'}});
    });
  }

}
